module.exports = __webpack_public_path__ + "img/android.5357063e.png";